module.exports = __webpack_public_path__ + "static/media/Twitter.3153377d.svg";